import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "start-setup" }
const _hoisted_2 = { class: "start-setup__saddle" }
const _hoisted_3 = { class: "start-setup__row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "start-setup__row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "start-setup__handlebar" }
const _hoisted_10 = { class: "start-setup__row" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "start-setup__row" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "start-setup__crankset" }
const _hoisted_17 = { class: "start-setup__row" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "start-setup__pedals" }
const _hoisted_21 = { class: "start-setup__row" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "start-setup__bike-setup" }
const _hoisted_25 = { class: "start-setup__small" }
const _hoisted_26 = { class: "start-setup__row" }
const _hoisted_27 = { class: "start-setup__row" }
const _hoisted_28 = { class: "start-setup__row" }
const _hoisted_29 = {
  key: 1,
  class: "start-setup__loader"
}

import { storeToRefs } from 'pinia'
import { usePositionStore } from '@/store/positionStore'
import { useBikeStore } from '@/store/bikeStore'
import { BfLoader } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'StartSetup',
  setup(__props) {

const { t } = useI18n()
const positionStore = usePositionStore()
const bikeStore = useBikeStore()

const { startPosition } = storeToRefs(positionStore)
const { bikeData, bikeSetup } = storeToRefs(bikeStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.saddle')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.position.index')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.x')), 1),
        (_unref(startPosition).saddleX)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(`${_unref(startPosition).saddleX} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.y')), 1),
        (_unref(startPosition).saddleY)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(`${_unref(startPosition).saddleY} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.handlebar')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.position.index')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.x')), 1),
        (_unref(startPosition).handlebarX)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(`${_unref(startPosition).handlebarX * -1} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.y')), 1),
        (_unref(startPosition).handlebarY)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(`${_unref(startPosition).handlebarY} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.crankset')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.specs')), 1),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.crankLength')), 1),
        (_unref(bikeData)?.CRANK_LENGTH)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(`${_unref(bikeData)?.CRANK_LENGTH} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.pedals')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.specs')), 1),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.size.height')), 1),
        (_unref(bikeData)?.PEDAL_HEIGHT)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(`${_unref(bikeData)?.PEDAL_HEIGHT} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.setup')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.distances')), 1),
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('measurement.tapeMeasure')), 1),
      (_unref(bikeData) && _unref(bikeSetup))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.saddleHeight')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(bikeSetup)?.SADDLE_HEIGHT
                ? `${_unref(bikeSetup)?.SADDLE_HEIGHT} ${_unref(t)('common.unit.mm')}`
                : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.saddleHandlebar')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(bikeSetup)?.SADDLE_HANDLEBAR_DISTANCE
                ? `${_unref(bikeSetup)?.SADDLE_HANDLEBAR_DISTANCE} ${_unref(t)('common.unit.mm')}`
                : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.saddleHandlebarDrop')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(bikeSetup)?.SADDLE_HANDLEBAR_DROP
                ? `${_unref(bikeSetup)?.SADDLE_HANDLEBAR_DROP} ${_unref(t)('common.unit.mm')}`
                : '-'), 1)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_unref(BfLoader))
          ]))
    ])
  ]))
}
}

})